var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleBar"},[_c('div',{staticClass:"titleBarBg",style:({backgroundImage: _vm.finalHomeConfig.dailyTrophyMostBg ? `url(${_vm.finalHomeConfig.dailyTrophyMostBg})` : '', backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center'})},[_c('h3',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }